import React, { PureComponent } from 'react';
import PropType from 'prop-types';
import { translate } from 'react-i18next';

export class HomePage extends PureComponent {
  static propTypes = {
    t: PropType.func,
  }

  static defaultProps = {
    t: (str) => str,
  }

  render() {
    return (
      <div>
        <section className="section">
          <div className="container">
            <div className="container">
              <h1 className="title">
                {this.props.t('HOME_TITLE')}
              </h1>
              <p>{this.props.t('HOME_SUBTITLE')}</p>
            </div>
          </div>
        </section>
        <section className="section">
          <div className="container">
            <div className="columns is-multiline">
              <div className="column"><h2 className="is-primary">{this.props.t('HOME_CONTENT_1')}</h2></div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default translate()(HomePage);
